import { pluralize } from '@infinex-private/ts-utils/string';

import { CustodyEmblemFromWalletId } from '..';
import type { WalletSourceMetadata } from '../../features/balances';
import { CustodyEmblemGroup } from '../custody/CustodyEmblemGroup';

export function TokenSourceWallets({
  sources,
  isDisabled,
}: {
  sources: WalletSourceMetadata[];
  isDisabled: boolean;
}) {
  if (sources.length === 0) {
    return null;
  }

  if (sources.length === 1) {
    const source = sources[0];
    return (
      <div className="flex shrink items-center gap-1.5">
        {/* Wallet-less sources resolve on their reserved id ('vault', or the
            confidential wallet's synthetic source id) */}
        <CustodyEmblemFromWalletId
          walletId={source.walletId ?? source.id}
          isDisabled={isDisabled}
          size="small"
        />

        {/* Mobile keeps just the wallet icon — the name doesn't fit the row */}
        <span className="max-w-[150px] truncate text-left max-sm:hidden">
          {source.label}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5">
      <CustodyEmblemGroup
        custodyMetadata={sources.map((source) => ({
          type: source.custody,
          label: source.label,
          walletId: source.walletId,
        }))}
      />
      <span className="max-sm:hidden">
        {pluralize(sources.length, 'Wallet')}
      </span>
    </div>
  );
}
